<template>
    <div class="match-file-attaching">
        <LinceAttachFile
            :file="file" 
            @update:file="onAttach"
        />
    </div>
</template>

<script>
export default {
    name: 'MatchFileAttaching',
    data: () => ({
        formatFile: ['.xls', '.xlsx'],
        title: 'Перетащите сюда файл или выберите на компьютере до 10 mb',
        file: null
    }),
    methods: {
        /**
         * Событие прикрепления файла
         * @param {Object} file - объект файла
         */
        onAttach(file = null) {
            if (file !== null) {
                this.file = file;
                this.$emit('attach', file);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .match-file-attaching {
        &__attach {
            max-height: 466px;
        }
    }
</style>
